import React from 'react'
import DoNotTranslateInput from './DoNotTranslateInput'
import { htmlToTextCount } from 'libs/text'
import { useField } from 'formik'
import { curry, pick } from 'ramda'

export const textLengthValiator = curry((maxLength, values, value) => {
  return htmlToTextCount(value) <= maxLength
})

function DoNotTranslateEditorFormik(props) {
  const [field, meta, helpers] = useField(props.name)
  const importedProps = pick(
    [
      'classes',
      'id',
      'label',
      'name',
      'maxLength',
      'value',
      'textStatus',
      'controls',
      'required',
      'isControlsInline',
      'isDoNotTranslateEnable',
      'isNoRichFormat',
      'linkEnabled',
      'tabIndex',
      'extraMsg',
      'readOnly',
      'onUploading',
      'onUploaded',
      'scrollableContainer',
      'onChangeImage',
      'placeholder',
      'isAIEnabled',
      'aiGenerateTextUpdated',
      'onGenerateContentWithAIClick',
    ],
    props,
  )

  const value = field.value
  const setValue = helpers.setValue

  const changeValue = React.useCallback(
    function (value) {
      setValue(value)
      if (props.onChange) {
        props.onChange(value)
      }
    },
    [props, setValue],
  )

  return (
    <DoNotTranslateInput
      {...importedProps}
      value={value}
      onChange={changeValue}
      touched={meta.touched}
      error={meta.error}
    />
  )
}

export default React.memo(DoNotTranslateEditorFormik)
